/**
 * @generated SignedSource<<b200da6c611e87678436b26da00659d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
export type SendTasksToAdoInput = {
  ids?: ReadonlyArray<string | null> | null;
  workitemType?: string | null;
  projectId?: string | null;
  adoState?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type sendTasksToAdoMutation$variables = {
  input: SendTasksToAdoInput;
};
export type sendTasksToAdoMutation$data = {
  readonly sendTasksToAdo: {
    readonly tasks: ReadonlyArray<{
      readonly id: string;
      readonly vstsId: string | null;
      readonly name: string | null;
      readonly statusColumnV2: {
        readonly id: string;
        readonly name: string | null;
        readonly category: STATUS_CATEGORY | null;
      } | null;
    } | null> | null;
    readonly updatedTasksIds: ReadonlyArray<string | null> | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type sendTasksToAdoMutation = {
  variables: sendTasksToAdoMutation$variables;
  response: sendTasksToAdoMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendTasksToAdoPayload",
    "kind": "LinkedField",
    "name": "sendTasksToAdo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "tasks",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vstsId",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusColumnV2",
            "kind": "LinkedField",
            "name": "statusColumnV2",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedTasksIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendTasksToAdoMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendTasksToAdoMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "93d53445a2d0b60a528fc36856eeb558",
    "id": null,
    "metadata": {},
    "name": "sendTasksToAdoMutation",
    "operationKind": "mutation",
    "text": "mutation sendTasksToAdoMutation(\n  $input: SendTasksToAdoInput!\n) {\n  sendTasksToAdo(input: $input) {\n    tasks {\n      id\n      vstsId\n      name\n      statusColumnV2 {\n        id\n        name\n        category\n      }\n    }\n    updatedTasksIds\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "3923e5dcdb3116a330fc933ab3a41b6e";

export default node;
